interface IParams {
  isMasterMoneySource: boolean;
  isSubagentSpendLimit: boolean;
  isAgencyBalanceVisible: boolean;
}

export const getIsShowAgencyBalance = (params: IParams): boolean => {
  const { isMasterMoneySource, isSubagentSpendLimit, isAgencyBalanceVisible } = params;

  return !isMasterMoneySource || isSubagentSpendLimit || isAgencyBalanceVisible;
};
